import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor, MatIconButton } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SidenavService } from '../../service/sidenav.service';

@Component({
  selector: 'app-public-toolbar',
  imports: [
    MatAnchor,
    MatIcon,
    MatIconButton,
    MatToolbarModule,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: './public-toolbar.component.html',
  styleUrl: './public-toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicToolbarComponent {
  private sidenavService = inject(SidenavService);

  showMenuButton = input<boolean>(false);

  protected readonly environment = environment;

  toggleSidenav() {
    this.sidenavService.toggle();
  }
}
